import { Form, Button, ConfigProvider } from 'antd';
// import IDown from '@imgs/icons/down.svg';

import { useMount, useUnmount } from 'ahooks';
import { useEffect, useMemo, useState, useRef } from 'react';
import classNames from 'classnames';

import type { FormProps } from 'antd';

import styles from './index.less';
import React from 'react';

//  折叠后会截取掉被隐藏的FormItem，所以form获取不到被截取的表单FormItem
type AdvancedFormProps = {
  form: any; // Form.useform()
  line?: number; // 折叠展示行数 不传则不折叠
  children?: React.ReactNode | Element[]; // 子元素 Form.Item
  buttons?: React.ReactNode | Element[]; // 自定义按钮
  onSearch?: React.MouseEventHandler<HTMLElement>; // 无自定义按钮 查询事件
  resetForm?: React.MouseEventHandler<HTMLElement>; // 无自定义按钮 重置事件
  formProps?: FormProps; // 其余的Form参数
  defaultExpand?: boolean; // 是否默认展开 仅在有line时生效
  operateContent?: React.ReactNode;
  isGhostBtn?: boolean;
  isBorderRadius?: boolean;
  isInvoice?: boolean; // 发票样式不处理
};

const widthLimitList = [1104, 1192, 1496];
export default function AdvancedForm(props: AdvancedFormProps) {
  const {
    line,
    buttons,
    onSearch,
    resetForm,
    children: originChildren,
    defaultExpand,
  } = props;
  const ref = useRef<HTMLDivElement>(null);
  // 使用 useRef 存储 ResizeObserver 实例，避免在重渲染时丢失引用
  const resizeHandlerRef = useRef<ResizeObserver | null>(null);
  // 使用 useRef 追踪组件是否已挂载，防止在卸载后更新状态
  const isMountedRef = useRef<boolean>(false);
  const [type, setType] = useState<number>(0);
  const [children, setChildren] = useState<any>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [hide, setHide] = useState<boolean>(!(line && defaultExpand));
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showToggle, setShowToggle] = useState<boolean>(false);
  // 过滤掉null\undefined\false
  const validChildren = useMemo(
    () => React.Children.toArray(originChildren),
    [originChildren]
  );

  const widthCompare = (width: number = 0) => {
    // 只在组件已挂载时更新状态，避免内存泄漏
    if (!isMountedRef.current) return;
    
    (widthLimitList || []).forEach((i, index) => {
      if (
        (width >= i &&
          (width < widthLimitList?.[index + 1] ||
            !widthLimitList?.[index + 1])) ||
        (width < i && index === 0)
      ) {
        setType(index);
      }
    });
  };
  // const toggle = () => {
  //   setHide(!hide);
  // };

  useEffect(() => {
    if (hide && line) {
      const list = validChildren.slice(0, (type + 3) * line);
      // setShowToggle(validChildren.length > type + 3);
      setChildren(list);
    } else if (!hide && line) {
      // setShowToggle(validChildren.length > type + 3);
      setChildren(validChildren);
    } else {
      setChildren(validChildren);
    }
  }, [hide, type, validChildren, line]);

  useMount(() => {
    // 标记组件已挂载
    isMountedRef.current = true;
    
    const ele = ref.current;
    widthCompare(ele?.getBoundingClientRect().width);
    
    if (ResizeObserver && ele) {
      resizeHandlerRef.current = new ResizeObserver((entries) => {
        for (const entry of entries) {
          const { width } = entry?.target?.getBoundingClientRect();
          widthCompare(width);
        }
      });
      resizeHandlerRef.current.observe(ele);
    }
  });
  
  useUnmount(() => {
    // 标记组件已卸载，防止后续状态更新
    isMountedRef.current = false;
    
    // 清理 ResizeObserver
    if (resizeHandlerRef.current) {
      resizeHandlerRef.current.disconnect();
      resizeHandlerRef.current = null;
    }
  });

  return (
    <div
      className={classNames(
        styles['advanced-form'],
        styles[`flex-${type}`],
        props.isBorderRadius
          ? styles['rounded-form']
          : styles['bottom-bordered-form'],
        props.isInvoice ? styles['advanced-form-invoice'] : ''
      )}
      ref={ref}
    >
      <Form form={props?.form} layout={'vertical'} {...props?.formProps}>
        {line ? children : validChildren}

        <div className={styles['buttons-search']}>
          {resetForm ? <Button onClick={resetForm} ghost type='primary'>重置</Button> : ''}
          {onSearch ? (
            <Button type='primary' onClick={onSearch}>
              查询
            </Button>
          ) : (
            ''
          )}
        </div>
      </Form>
      {props?.operateContent || buttons ? (
        <div className={styles.controller}>
          {props?.operateContent}
          <ConfigProvider autoInsertSpaceInButton={false}>
            {!buttons ? '' : buttons}
          </ConfigProvider>
        </div>
      ) : undefined}
    </div>
  );
}
